import { Alert, Linking, Platform } from "react-native";

import { APP_STORE_LINK, PLAY_STORE_LINK } from "../links";

/**
 * Shows an alert prompting the user to update the app
 * @param isForced If true, doesn't show a cancel button
 */
export function showAppUpdateAlert(isForced = true): void {
  // Get the appropriate store URL based on platform
  const appStoreUrl = Platform.OS === "ios" ? APP_STORE_LINK : PLAY_STORE_LINK;

  // Show the alert
  Alert.alert(
    "Update Available",
    "A new version of Kai Social is available. Please update to the latest version.",
    [{ text: "Update Now", onPress: () => Linking.openURL(appStoreUrl) }],
    { cancelable: !isForced },
  );
}
